const projectList = {
  react: [
    {
     projectName :"Pomodoro Clock",
     projectDescription:"A time management, responsive React app based on the timeboxing concept, that provides customizable countdowns for working sessions.",
     projectThumbNailLink :"./assets/projects/react/reactP5.png",
     projectTech :"ReactJs, SCSS and HTML5",
     projectHref :"https://codepen.io/Meikochow/full/BPZEGz/",
     code:'codepen',
     codeLink:"https://codepen.io/Meikochow/pen/BPZEGz"
    },
    {
     projectName :"Calculator",
     projectDescription:"Responsive React app used to perform basic arithmetic calculations.",
     projectThumbNailLink :"./assets/projects/react/reactP4.png",
     projectTech :"ReactJs, SCSS and HTML5",
     projectHref :"https://codepen.io/Meikochow/full/PBGKPQ/",
     code:'codepen',
     codeLink:"https://codepen.io/Meikochow/pen/PBGKPQ/"
    },
    {
     projectName :"Drum Machine",
     projectDescription:"Responsive React electronic percussion instrument, allowing the user to play various sound elements via keys, mouse or touch.",
     projectThumbNailLink :"./assets/projects/react/reactP3.png",
     projectTech :"ReactJs, SCSS and HTML5",
     projectHref :"https://codepen.io/Meikochow/full/WyVqQp/",
     code:'codepen',
     codeLink:"https://codepen.io/Meikochow/pen/WyVqQp/"
    },
    {
     projectName :"Markdown Previewer",
     projectDescription:"Responsive Markdown markup language React App, featuring a side-by-side preview window rendering the code directly in a WYSIWYG fashion.",
     projectThumbNailLink :"./assets/projects/react/reactP2.png",
     projectTech :"ReactJs, SCSS and HTML5",
     projectHref :"https://codepen.io/Meikochow/full/eKwpXO/",
     code:'codepen',
     codeLink:"https://codepen.io/Meikochow/pen/eKwpXO/"
    },
    // {
    //  projectName :"Math Marathon",
    //  projectDescription:"Responsive ReactJs game of selecting the correct result against time, with a shareable score",
    //  projectThumbNailLink :"./assets/projects/games/mathMarathon.png",
    //  projectTech :"ReactJs, SCSS and HTML5",
    //  projectHref :"https://codepen.io/Meikochow/full/YjBJmg/",
    //  code:'codepen',
    //  codeLink:"https://codepen.io/Meikochow/pen/YjBJmg/"
    // },
    // {
    // projectName :"Anime Card Match",
    // projectDescription:"A ReactJs, Anime-themed, memory game",
    // projectThumbNailLink :"./assets/projects/react/flip.png",
    // projectTech :"ReactJs, CSS, keyframes and HTML5",
    // projectHref :"https://anime-flip.glitch.me/",
    // code:'github',
    // codeLink:"https://github.com/Meikochow/anime-flip"
    // },
    // {
    // projectName :"PuzzleIt",
    // projectDescription:"A ReactJs puzzle game",
    // projectThumbNailLink :"./assets/projects/react/puzzleIt.PNG",
    // projectTech :"ReactJs, CSS, keyframes and HTML5",
    // projectHref :"https://puzzle-it.glitch.me/",
    // code:'github',
    // codeLink:"https://github.com/Meikochow/PuzzleIt"
    // }
  ],
  javascript: [
    {
     projectName :"Local Weather App",
     projectDescription:"Responsive jQuery app that uses the HTML geolocation of your device to present the weather conditions of your location.",
     projectThumbNailLink :"./assets/projects/Javascript/weather app.png",
     projectTech :"JavaScript + jQuery, Ajax, SCSS and HTML5",
     projectHref :"https://codepen.io/Meikochow/full/oEmgXa/",
     code:'codepen',
     codeLink:"https://codepen.io/Meikochow/pen/oEmgXa/"
    },
    {
     projectName :"Fold-Wiki",
     projectDescription:"Responsive App that accepts user input and renders the 20 most relatable Wikipedia articles by using the Wiki Api.",
     projectThumbNailLink :"./assets/projects/Javascript/wikiViewer.png",
     projectTech :"JavaScript + jQuery, Ajax, SCSS and HTML5",
     projectHref :"https://codepen.io/Meikochow/full/EQBWgV/",
     code:'codepen',
     codeLink:"https://codepen.io/Meikochow/pen/EQBWgV/"
    },
    {
     projectName :"Twitch TV status App",
     projectDescription:"Responsive Twitch.tv Api rendering App that gets your custom streamers' data and presents it to the user.",
     projectThumbNailLink :"./assets/projects/Javascript/twitchApi.png",
     projectTech :"JavaScript + jQuery, Ajax, SCSS and HTML5",
     projectHref :"https://codepen.io/Meikochow/full/OvVzvM/",
     code:'codepen',
     codeLink:"https://codepen.io/Meikochow/pen/OvVzvM/"
    },
    {
     projectName :"Tribute Page to Asani Inio",
     projectDescription:"A responsive Tribute Web Page, based on applied accessibility guidelines",
     projectThumbNailLink :"./assets/projects/Javascript/tributePage.png",
     projectTech :"JavaScript + jQuery, SCSS and HTML5",
     projectHref :"https://codepen.io/Meikochow/full/PaNpvB/",
     code:'codepen',
     codeLink:"https://codepen.io/Meikochow/pen/PaNpvB/"
    },
    // {
    //  projectName :"Tic Tac Toe",
    //  projectDescription:"Tic-Tac-Toe game based on the MinMax Algorithm, designed with a customizable difficulty level which can be shared on your facebook.",
    //  projectThumbNailLink :"./assets/projects/games/ticTacToe.png",
    //  projectTech :"JavaScript + jQuery, SCSS and HTML5",
    //  projectHref :"https://codepen.io/Meikochow/full/odoqpe/",
    //  code:'codepen',
    //  codeLink:"https://codepen.io/Meikochow/pen/odoqpe/"
    // },
    // {
    //  projectName :"Simon Game",
    //  projectDescription:"Simon Game app that creates a series of sounds and lights which require the user to repeat the sequence, based on their memory.",
    //  projectThumbNailLink :"./assets/projects/games/simonGame.png",
    //  projectTech :"JavaScript + jQuery, SCSS and HTML5",
    //  projectHref :"https://codepen.io/Meikochow/full/OZEMgz/",
    //  code:'codepen',
    //  codeLink:"https://codepen.io/Meikochow/pen/OZEMgz/"
    // },
  ],
  fullStack: [
    {projectName :"Awesome Book Store",
    projectDescription:"MERN Stack, CRUD Application deployed to Heroku, all data including images stored in the db. User can add/remove items to/from cart",
    projectThumbNailLink :"./assets/projects/fullStack/awesome_book_store.png",
    projectTech : "Node, Express,React, Redux, MongoDB, SCSS, Ant-Design",
    projectHref :"https://fierce-bayou-11189.herokuapp.com/",
    code:'github',
    codeLink:"https://github.com/Meikochow/MERN_book_store"
  },
    {projectName :"Anonymous message board",
    projectDescription:"Full-Stack app that allows anonymous users to create custom boards, threads and messages",
    projectThumbNailLink :"./assets/projects/fullStack/anon board.png",
    projectTech : "Node, Express, MongoDB, JS+jQuery, HelmetJs, Bcrypt, Mocha, CSS3 and HTML5",
    projectHref :"https://surf-code.glitch.me/",
    code:'github',
    codeLink:"https://github.com/Meikochow/anon-message-board"
  },
  {
   projectName :"Issue Tracker",
   projectDescription:"Full-Stack app that allows users to post, manage and reply to work related issues.",
   projectThumbNailLink :"./assets/projects/fullStack/issue tracker.png",
   projectTech :"Node, Express, MongoDB, JS+jQuery, HelmetJs, Mocha, CSS3 and HTML5",
   projectHref :"https://rainbow-jump.glitch.me/apitest/",
   code:'github',
   codeLink:"https://github.com/Meikochow/ISQA_4---Issue-Tracker"
  },
  {
   projectName :"URL Shortener Microservice",
   projectDescription:"Full-Stack app that accepts valid urls and returns a functional shortened version. ",
   projectThumbNailLink :"./assets/projects/fullStack/urlsortener.png",
   projectTech :"Node, Express, MongoDB, JS+jQuery, Mocha, CSS3 and HTML5",
   projectHref :"https://time-snipe.glitch.me/",
   code:'github',
   codeLink:"https://github.com/Meikochow/-URL-Shortener-Microservice-for-freeCodeCamp"
  },
  {
   projectName :"Personal library",
   projectDescription:"Full-Stack app that allows the user to store book titles and write reviews.",
   projectThumbNailLink :"./assets/projects/fullStack/manga library.png",
   projectTech :"Node, Express, MongoDB, JS+jQuery,HelmetJs, Mocha, CSS3 and HTML5",
   projectHref :"https://meadow-swordfish.glitch.me/",
   code:'github',
   codeLink:"https://github.com/Meikochow/ISQA-Project---Personal-Library"
  },
  {
   projectName :"Stock Price Checker",
   projectDescription:"Full-Stack app that fetches real time stock price from a third-party api and saves the users' likes of the given stock in the DB. ",
   projectThumbNailLink :"./assets/projects/fullStack/stock price checker.png",
   projectTech :"Node, Express, MongoDB, JS+jQuery,HelmetJs, Mocha, CSS3 and HTML5",
   projectHref :"https://charming-cilantro.glitch.me/",
   code:'github',
   codeLink:"https://github.com/Meikochow/Stock-Price-Checker"
  },
  {
   projectName :"Metric ↔ Imperial unit converter",
   projectDescription:"Full-Stack app built using Node and Express which converts imperial units to metrics and vice versa.",
   projectThumbNailLink :"./assets/projects/fullStack/metric imperial converter.png",
   projectTech :"Node, Express, MongoDB, JS+jQuery,HelmetJs, Mocha, CSS3 and HTML5",
   projectHref :"https://apple-pear-1.glitch.me/",
   code:'github',
   codeLink:"https://github.com/Meikochow/Information-Security-and-Quality-Assurance-Projects---Metric-Imperial-Converter"
  }
  ],
  games: [
    {
    projectName :"PuzzleIt",
    projectDescription:"A ReactJs puzzle game",
    projectThumbNailLink :"./assets/projects/games/puzzleIt.PNG",
    projectTech :"ReactJs, CSS, keyframes and HTML5",
    projectHref :"https://puzzle-it.glitch.me/",
    code:'github',
    codeLink:"https://github.com/Meikochow/PuzzleIt"
  },
  {
   projectName :"Tic Tac Toe",
   projectDescription:"Tic-Tac-Toe game based on the MinMax Algorithm, designed with a customizable difficulty level which can be shared on your facebook.",
   projectThumbNailLink :"./assets/projects/games/ticTacToe.png",
   projectTech :"JavaScript + jQuery, SCSS and HTML5",
   projectHref :"https://codepen.io/Meikochow/full/odoqpe/",
   code:'codepen',
   codeLink:"https://codepen.io/Meikochow/pen/odoqpe/"
  },
  {
   projectName :"Simon Game",
   projectDescription:"Simon Game app that creates a series of sounds and lights which require the user to repeat the sequence, based on their memory.",
   projectThumbNailLink :"./assets/projects/games/simonGame.png",
   projectTech :"JavaScript + jQuery, SCSS and HTML5",
   projectHref :"https://codepen.io/Meikochow/full/OZEMgz/",
   code:'codepen',
   codeLink:"https://codepen.io/Meikochow/pen/OZEMgz/"
  },
  {
   projectName :"Morty Run",
   projectDescription:"A platform Rick & Morty themed obstacle game.",
   projectThumbNailLink :"./assets/projects/games/mortyRun.png",
   projectTech :"JavaScript + jQuery, Canvas, SCSS and HTML5",
   projectHref :"https://rawgit.com/Meikochow/Morty-Run/master/index.html",
   code:'github',
   codeLink:"https://github.com/Meikochow/Morty-Run"
  },
  {
   projectName :"Snake",
   projectDescription:"A Javascript Snake game",
   projectThumbNailLink :"./assets/projects/games/snakeJs.png",
   projectTech :"JavaScript + jQuery, Canvas, SCSS and HTML5",
   projectHref :"https://rawgit.com/Meikochow/Snake-Game-JavaScript/master/index.html",
   code:'github',
   codeLink:"https://github.com/Meikochow/Snake-Game-JavaScript"
  },
  {
   projectName :"Math Marathon",
   projectDescription:"Responsive ReactJs game of selecting the correct result against time, with a shareable score",
   projectThumbNailLink :"./assets/projects/games/mathMarathon.png",
   projectTech :"ReactJs, SCSS and HTML5",
   projectHref :"https://codepen.io/Meikochow/full/YjBJmg/",
   code:'codepen',
   codeLink:"https://codepen.io/Meikochow/pen/YjBJmg/"
  },
  {
   projectName :"Stack Attack",
   projectDescription:"Canvas 'Space Attack' - like game",
   projectThumbNailLink :"./assets/projects/games/stack-attack.png",
   projectTech :"JavaScript, CSS3, HTML5",
   projectHref :"https://codepen.io/Meikochow/full/mzeOYr",
   code:'codepen',
   codeLink:"https://codepen.io/Meikochow/pen/mzeOYr"
  },
  {
  projectName :"5 Seconds Rule",
  projectDescription:"A ReactJs game where You've got five seconds to name three things in a category",
  projectThumbNailLink :"./assets/projects/games/5secrule.png",
  projectTech :"ReactJs, CSS and HTML5",
  projectHref :"https://5-seconds-rule.glitch.me/",
  code:'github',
  codeLink:"https://github.com/Meikochow/5-seconds-rule"
  },
  {
  projectName :"Anime Card Match",
  projectDescription:"A ReactJs, Anime-themed, memory game",
  projectThumbNailLink :"./assets/projects/games/flip.png",
  projectTech :"ReactJs, CSS, keyframes and HTML5",
  projectHref :"https://anime-flip-card-game.onrender.com/",
  code:'github',
  codeLink:"https://github.com/Meikochow/anime-flip"
  }
  ],
  D3: [
    {
     projectName :"Bar Chart",
     projectDescription:"D3 App displaying data in a Bar Chart Maner",
     projectThumbNailLink :"./assets/projects/D3/D3-1-barChart.png",
     projectTech :"D3.js, CSS3 and HTML5",
     projectHref :"https://codepen.io/Meikochow/full/qLEopO",
     code:'codepen',
     codeLink:"https://codepen.io/Meikochow/pen/qLEopO"
    },
    {
     projectName :"Scatter Plot",
     projectDescription:"D3 App that displays data in a Scatter Plot maner",
     projectThumbNailLink :"./assets/projects/D3/D3-2-scatterPlot.png",
     projectTech :"D3 CSS3 and HTML5",
     projectHref :"https://codepen.io/Meikochow/full/ZVqeQM",
     code:'codepen',
     codeLink:"https://codepen.io/Meikochow/pen/ZVqeQM"
    },
    {
     projectName :"Heat Map",
     projectDescription:"D3 App that displays data in a Heat Map pattern",
     projectThumbNailLink :"./assets/projects/D3/D3-3-heatMap.png",
     projectTech :"D3.js, CSS3 and HTML5",
     projectHref :"https://codepen.io/Meikochow/full/KbraGa",
     code:'codepen',
     codeLink:"https://codepen.io/Meikochow/pen/KbraGa"
    },
    {
     projectName :"Chloropleth Map",
     projectDescription:"D3 App that displays map data",
     projectThumbNailLink :"./assets/projects/D3/D3-4-ChloroplethMap.png",
     projectTech :"D3.js, CSS3 and HTML5",
     projectHref :"https://codepen.io/Meikochow/full/JwxEoR",
     code:'codepen',
     codeLink:"https://codepen.io/Meikochow/pen/JwxEoR"
    },
    {
     projectName :"Tree Map",
     projectDescription:"D3 App that displays data in a Tree Map pattern",
     projectThumbNailLink :"./assets/projects/D3/D3-5-TreeMap.png",
     projectTech :"D3.js, CSS3 and HTML5",
     projectHref :"https://codepen.io/Meikochow/full/QzYqNO",
     code:'codepen',
     codeLink:"https://codepen.io/Meikochow/pen/QzYqNO"
    },

  ]
}
 export default projectList;
